module.exports = __webpack_public_path__ + "media/images/emblems/Villars-le-Terroir-coat_of_arms-68888584e92c7f1c079c752143e97e12.svg";